import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
// prettier-ignore
const Stall = () => import('@/entities/stall/stall.vue');
// prettier-ignore
const StallUpdate = () => import('@/entities/stall/stall-update.vue');
// prettier-ignore
const StallDetails = () => import('@/entities/stall/stall-details.vue');
// prettier-ignore
const Pferd = () => import('@/entities/pferd/pferd.vue');
// prettier-ignore
const PferdUpdate = () => import('@/entities/pferd/pferd-update.vue');
// prettier-ignore
const PferdDetails = () => import('@/entities/pferd/pferd-details.vue');
// prettier-ignore
const Termin = () => import('@/entities/termin/termin.vue');
// prettier-ignore
const TerminUpdate = () => import('@/entities/termin/termin-update.vue');
// prettier-ignore
const TerminDetails = () => import('@/entities/termin/termin-details.vue');
const TerminLieferschein = () => import('@/entities/termin/termin-lieferschein.vue');
// prettier-ignore
const Kunde = () => import('@/entities/kunde/kunde.vue');
// prettier-ignore
const KundeUpdate = () => import('@/entities/kunde/kunde-update.vue');
// prettier-ignore
const KundeDetails = () => import('@/entities/kunde/kunde-details.vue');
// prettier-ignore
const Zusatzleistung = () => import('@/entities/zusatzleistung/zusatzleistung.vue');
// prettier-ignore
const ZusatzleistungUpdate = () => import('@/entities/zusatzleistung/zusatzleistung-update.vue');
// prettier-ignore
const ZusatzleistungDetails = () => import('@/entities/zusatzleistung/zusatzleistung-details.vue');
const Grundleistung = () => import('@/entities/grundleistung/grundleistung.vue');
const GrundleistungUpdate = () => import('@/entities/grundleistung/grundleistung-update.vue');
const Ausgabe = () => import('@/entities/ausgabe/ausgabe.vue');
const AusgabeUpdate = () => import('@/entities/ausgabe/ausgabe-update.vue');
const AusgabeDetails = () => import('@/entities/ausgabe/ausgabe-details.vue');
const Bezahlmgl = () => import('@/entities/bezahlmgl/bezahlmgl.vue');
const BezahlmglUpdate = () => import('@/entities/bezahlmgl/bezahlmgl-update.vue');
const Material = () => import('@/entities/material/material.vue');
const MaterialUpdate = () => import('@/entities/material/material-update.vue');
const MaterialAdd = () => import('@/entities/material/material-add.vue');
const Notifications = () => import('@/entities/notification/notification.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default [
  {
    path: '/stall',
    name: 'Stall',
    component: Stall,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/stall/new',
    name: 'StallCreate',
    component: StallUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/stall/:stallId/edit',
    name: 'StallEdit',
    component: StallUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/stall/:stallId/view',
    name: 'StallView',
    component: StallDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/pferd',
    name: 'Pferd',
    component: Pferd,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/pferd/new',
    name: 'PferdCreate',
    component: PferdUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/pferd/:pferdId/edit',
    name: 'PferdEdit',
    component: PferdUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/pferd/:pferdId/view',
    name: 'PferdView',
    component: PferdDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/termin',
    name: 'Termin',
    component: Termin,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/termin/new',
    name: 'TerminCreate',
    component: TerminUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/termin/:terminId/edit',
    name: 'TerminEdit',
    component: TerminUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/termin/:terminId/view',
    name: 'TerminView',
    component: TerminDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/termin/:terminId/lieferschein',
    name: 'TerminLieferschein',
    component: TerminLieferschein,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/kunde',
    name: 'Kunde',
    component: Kunde,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kunde/new',
    name: 'KundeCreate',
    component: KundeUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kunde/:kundeId/edit',
    name: 'KundeEdit',
    component: KundeUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/kunde/:kundeId/view',
    name: 'KundeView',
    component: KundeDetails,
    meta: { authorities: [Authority.USER] },
  },

  {
    path: '/zusatzleistung',
    name: 'Zusatzleistung',
    component: Zusatzleistung,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/zusatzleistung/new',
    name: 'ZusatzleistungCreate',
    component: ZusatzleistungUpdate,
    meta: { authorities: [Authority.BUCHHALTUNG, Authority.CHEF] },
  },
  {
    path: '/zusatzleistung/:zusatzleistungId/edit',
    name: 'ZusatzleistungEdit',
    component: ZusatzleistungUpdate,
    meta: { authorities: [Authority.BUCHHALTUNG, Authority.CHEF] },
  },
  {
    path: '/zusatzleistung/:zusatzleistungId/view',
    name: 'ZusatzleistungView',
    component: ZusatzleistungDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/grundleistung',
    name: 'Grundleistung',
    component: Grundleistung,
    meta: { authorities: [Authority.BUCHHALTUNG] },
  },
  {
    path: '/grundleistung/new',
    name: 'GrundleistungCreate',
    component: GrundleistungUpdate,
    meta: { authorities: [Authority.BUCHHALTUNG, Authority.CHEF] },
  },
  {
    path: '/grundleistung/:grundleistungId/edit',
    name: 'GrundleistungEdit',
    component: GrundleistungUpdate,
    meta: { authorities: [Authority.BUCHHALTUNG, Authority.CHEF] },
  },
  {
    path: '/bezahlmgl',
    name: 'Bezahlmgl',
    component: Bezahlmgl,
    meta: { authorities: [Authority.BUCHHALTUNG] },
  },
  {
    path: '/bezahlmgl/new',
    name: 'BezahlmglCreate',
    component: BezahlmglUpdate,
    meta: { authorities: [Authority.BUCHHALTUNG, Authority.CHEF] },
  },
  {
    path: '/bezahlmgl/:bezahlmglId/edit',
    name: 'BezahlmglEdit',
    component: BezahlmglUpdate,
    meta: { authorities: [Authority.BUCHHALTUNG, Authority.CHEF] },
  },
  {
    path: '/ausgabe',
    name: 'Ausgabe',
    component: Ausgabe,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/ausgabe/new',
    name: 'AusgabeCreate',
    component: AusgabeUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/ausgabe/:ausgabeId/edit',
    name: 'AusgabeEdit',
    component: AusgabeUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/ausgabe/:ausgabeId/view',
    name: 'AusgabeView',
    component: AusgabeDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/material',
    name: 'Material',
    component: Material,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/material/new',
    name: 'MaterialCreate',
    component: MaterialUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/material/:materialId/edit',
    name: 'MaterialEdit',
    component: MaterialUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/materialAdd',
    name: 'MaterialAdd',
    component: MaterialAdd,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { authorities: [Authority.USER] },
  },
  // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
];
